import { useEffect, useState } from "react";
import { NAV } from "@/constants/testIds";

const links = [
  { id: "packages", label: "Packages", testid: NAV.linkPackages },
  { id: "addons", label: "Add-ons", testid: NAV.linkAddons },
  { id: "how", label: "How it works", testid: NAV.linkHow },
  { id: "quote", label: "Contact", testid: NAV.linkContact },
];

export default function Header({ onQuote }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-[#F8F6F2]/85 border-b border-[#E9DED1]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <button
          data-testid={NAV.logo}
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-baseline gap-2 group"
        >
          <span className="font-serif text-2xl md:text-[28px] tracking-tight text-brand-ink leading-none">
            Ferreiro
          </span>
          <span className="font-serif italic text-xl md:text-2xl text-brand-terracotta leading-none">
            Play Co.
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={l.testid}
              onClick={() => scrollTo(l.id)}
              className="text-sm font-medium text-brand-mute hover:text-brand-terracotta transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          data-testid={NAV.ctaQuote}
          onClick={onQuote}
          className="hidden sm:inline-flex items-center gap-2 glass-btn-solid rounded-full px-6 py-3 text-sm font-medium transition-all duration-300"
        >
          Request a quote
          <span aria-hidden>→</span>
        </button>
      </div>
    </header>
  );
}
